<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลรหัสไปรษณีย์' : 'เพิ่มข้อมูลรหัสไปรษณีย์' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="postcode" class="form-label mb-0 required">รหัสไปรษณีย์</label></div>
      <div class="col-sm-8"><input type="text" class="form-control form-control-sm" id="postcode"
                                formControlName="postcode"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="subdistrictCode" class="form-label mb-0 required">รหัสตำบล/แขวง</label></div>
      <div class="col-sm-8">
        <app-subdistrict-autocomplete
          formControlName="subdistrictCode"
          [bindValue]="'code'"
          [initialDisplayText]="subdistrictDisplayText"
          (selected)="onSubdistrictSelected($event)">
        </app-subdistrict-autocomplete>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="districtCode" class="form-label mb-0 required">รหัสอำเภอ/เขต</label></div>
      <div class="col-sm-8">
        <app-district-autocomplete
          formControlName="districtCode"
          [bindValue]="'code'"
          [initialDisplayText]="districtDisplayText"
          (selected)="onDistrictSelected($event)">
        </app-district-autocomplete>
      </div>
    </div>

    @if (subdistrictDisplayText || districtDisplayText || provinceDisplayText || postcode?.subdistrictDisplay || postcode?.districtDisplay || postcode?.provinceDisplay) {
      <hr class="my-3">
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">ตำบล/แขวง</label></div>
        <div class="col-sm-8"><input class="form-control form-control-sm"
                                  [value]="subdistrictDisplayText || postcode?.subdistrictDisplay || '-'" readonly>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">อำเภอ/เขต</label></div>
        <div class="col-sm-8"><input class="form-control form-control-sm"
                                  [value]="districtDisplayText || postcode?.districtDisplay || '-'" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label class="form-label mb-0">จังหวัด</label></div>
        <div class="col-sm-8"><input class="form-control form-control-sm"
                                  [value]="provinceDisplayText || postcode?.provinceDisplay || '-'" readonly></div>
      </div>
    }

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay"
                                  readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay"
                                  readonly></div>
      </div>
    }
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก
    </button>
  }
</div>
